<!-- =========================================================================================
    File Name: ChartPolarArea.vue
    Description: Create polar area chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <chartjs-component-polar-area-chart :height=200 :data="data" :options="options"></chartjs-component-polar-area-chart>
</template>
<script>
import ChartjsComponentPolarAreaChart from "./ChartjsComponentPolarAreaChart.vue"
export default {
    data() {
      return {
        
      }
    },
    components: {
      ChartjsComponentPolarAreaChart
    },
    props:{
      data:{
        type:Object,
        required:true,
      },
      options:{
        type:Object,
        required:true,
      }
    }
}
</script>